import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = {
  key: 0,
  class: "text-left"
}
const _hoisted_3 = {
  key: 1,
  class: "pl-4 text-left"
}
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "text-left" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  style: {"height":"60vh"},
  class: "pa-1"
}
const _hoisted_15 = { style: {"cursor":"pointer"} }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_date_picker_wrapper = _resolveComponent("v-date-picker-wrapper")!
  const _component_oss_widget_embedder = _resolveComponent("oss-widget-embedder")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_AccountingBooklet = _resolveComponent("AccountingBooklet")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_GeneralLedgerExportDialog = _resolveComponent("GeneralLedgerExportDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.$vuetify.display.mobile)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": "",
                  class: "my-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "2" }, {
                      default: _withCtx(() => [
                        (_ctx.currentUser.profile.configuration.accounting.write)
                          ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                              key: 0,
                              block: "",
                              disabled: !_ctx.companyId || !_ctx.accountingPeriod,
                              loading: _ctx.exportFECLoading,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportDialog = true)),
                              "data-cy": "ExportAccounting-export"
                            }, {
                              default: _withCtx(() => _cache[67] || (_cache[67] = [
                                _createTextVNode("Export")
                              ])),
                              _: 1
                            }, 8, ["disabled", "loading"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_oss_dialog, {
                          modelValue: _ctx.exportDialog,
                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.exportDialog) = $event)),
                          title: "Export",
                          minWidth: "40vw",
                          maxWidth: "50vw",
                          "previous-display": _ctx.step !== 'default' && _ctx.isAllowedTo,
                          "previous-disabled": _ctx.step === 'default' || !_ctx.isAllowedTo,
                          onPrevious: _cache[58] || (_cache[58] = ($event: any) => (_ctx.previousStep())),
                          onClose: _ctx.defaultStep,
                          width: "60vw"
                        }, {
                          actions: _withCtx(() => [
                            (_ctx.actionBtnShow)
                              ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                                  key: 0,
                                  disabled: _ctx.actionBtnDisabled,
                                  rounded: "",
                                  block: "",
                                  onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.actionBtnFunction())),
                                  "data-cy": "ExportAccounting-valid",
                                  size: "x-large"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.actionBtnText), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_window, {
                              modelValue: _ctx.step,
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.step) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_window_item, { value: "default" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, {
                                      subheader: "",
                                      lines: "two"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.isTrainingOffer)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 0 }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_list_item, _mergeProps({
                                                  class: 
                                                    !_ctx.$vuetify.display.mobile
                                                        ? 'mb-2 oss-list-item'
                                                        : 'mb-2 px-2 oss-list-item'
                                                
                                                }, props), {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_btn_next)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => _cache[68] || (_cache[68] = [
                                                        _createTextVNode("Export FEC")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                                                      default: _withCtx(() => _cache[69] || (_cache[69] = [
                                                        _createTextVNode("Export du fichier FEC (avec ou sans les documents associés) sur la periode comptable selectionnée ou uniquement les écritures comptables non-exportées")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1040, ["class"])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("training-text.normal-text")), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 1,
                                              class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        ),
                                              onClick: _cache[1] || (_cache[1] = ($event: any) => {
                                            _ctx.fecDates();
                                            _ctx.step = 'export_fec_general';
                                        })
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_btn_next)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                    _createTextVNode("Export FEC")
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_list_item_subtitle, { style: {"white-space":"normal"} }, {
                                                  default: _withCtx(() => _cache[71] || (_cache[71] = [
                                                    _createTextVNode("Export du fichier FEC (avec ou sans les documents associés) sur la periode comptable selectionnée ou uniquement les écritures comptables non-exportées")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["class"])),
                                        (_ctx.isTrainingOffer)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 2 }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_list_item, _mergeProps({
                                                  class: 
                                                    !_ctx.$vuetify.display.mobile
                                                        ? 'mb-2 oss-list-item rounded-lg'
                                                        : 'mb-2 px-2 oss-list-item rounded-lg'
                                                
                                                }, props), {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_btn_next)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                        _createTextVNode("Export journal général")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_list_item_subtitle, null, {
                                                      default: _withCtx(() => _cache[73] || (_cache[73] = [
                                                        _createTextVNode("Export du journal général global ou partiel")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1040, ["class"])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("training-text.normal-text")), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 3,
                                              class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item rounded-lg'
                                                : 'mb-2 px-2 oss-list-item rounded-lg'
                                        ),
                                              disabled: !_ctx.companyId || !_ctx.accountingPeriod,
                                              onClick: _cache[2] || (_cache[2] = ($event: any) => {
                                            _ctx.fecDates();
                                            _ctx.step = 'export_log';
                                        })
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_btn_next)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[74] || (_cache[74] = [
                                                    _createTextVNode("Export journal général")
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                  default: _withCtx(() => _cache[75] || (_cache[75] = [
                                                    _createTextVNode("Export du journal général global ou partiel")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["class", "disabled"])),
                                        (_ctx.isTrainingOffer)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, { key: 4 }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_list_item, _mergeProps({
                                                  class: 
                                                    !_ctx.$vuetify.display.mobile
                                                        ? 'mb-2 oss-list-item rounded-lg'
                                                        : 'mb-2 px-2 oss-list-item rounded-lg'
                                                
                                                }, props), {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_btn_next)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => _cache[76] || (_cache[76] = [
                                                        _createTextVNode("Export du grand livre et/ou de la balance")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_list_item_subtitle)
                                                  ]),
                                                  _: 2
                                                }, 1040, ["class"])
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("training-text.normal-text")), 1)
                                              ]),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 5,
                                              class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item rounded-lg'
                                                : 'mb-2 px-2 oss-list-item rounded-lg'
                                        ),
                                              disabled: !_ctx.companyId || !_ctx.accountingPeriod,
                                              onClick: _cache[3] || (_cache[3] = ($event: any) => {
                                            _ctx.exportGeneralLedgerDialog = true;
                                            _ctx.fecDates();
                                        })
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_btn_next)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => _cache[77] || (_cache[77] = [
                                                    _createTextVNode("Export du grand livre et/ou de la balance")
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_list_item_subtitle)
                                              ]),
                                              _: 1
                                            }, 8, ["class", "disabled"])),
                                        (_ctx.isAllowedTo && _ctx.isUserHasAccess)
                                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: 6,
                                              class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        ),
                                              onClick: _cache[4] || (_cache[4] = ($event: any) => {
                                            _ctx.accountingBookletDialog = true;
                                            _ctx.exportDialog = false;
                                            _ctx.fecDates();
                                        })
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_v_btn_next)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, { "data-cy": "ExportAccounting-plaquette" }, {
                                                  default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                    _createTextVNode("Etats financiers")
                                                  ])),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                                                    _createTextVNode("Export état financier personnalisé")
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["class"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_list_item, {
                                          class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        ),
                                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                            _ctx.step = 'export_office_1';
                                            _ctx.fecDates();
                                        })
                                        }, {
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_btn_next)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title),
                                            _cache[81] || (_cache[81] = _createTextVNode("Export office ")),
                                            _createVNode(_component_v_list_item_subtitle, null, {
                                              default: _withCtx(() => _cache[80] || (_cache[80] = [
                                                _createTextVNode("Export de données dans un document office")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["class"]),
                                        (_ctx.extensions.length)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                              _createVNode(_component_v_divider, { class: "my-3" }),
                                              _createVNode(_component_v_list_item, {
                                                class: _normalizeClass(
                                                !_ctx.$vuetify.display.mobile
                                                    ? 'mb-2 oss-list-item'
                                                    : 'mb-2 px-2 oss-list-item'
                                            ),
                                                onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                                _ctx.step = 'export_extensions';
                                                _ctx.fecDates();
                                            })
                                              }, {
                                                append: _withCtx(() => [
                                                  _createVNode(_component_v_btn_next)
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, { "data-cy": "ExportAccounting-extensions" }, {
                                                    default: _withCtx(() => _cache[82] || (_cache[82] = [
                                                      _createTextVNode("Extensions")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_list_item_subtitle, null, {
                                                    default: _withCtx(() => _cache[83] || (_cache[83] = [
                                                      _createTextVNode("Vos extensions")
                                                    ])),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["class"])
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "export_fec_general" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_form, {
                                      modelValue: _ctx.isExportFECValid,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.isExportFECValid) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        (
                                            _ctx.selectedCompany &&
                                            !_ctx.selectedCompany.siret &&
                                            !_ctx.selectedCompany.siren
                                        )
                                          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                  default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                    _createElementVNode("h3", { style: {"color":"red"} }, " Afin de pouvoir générer un fichier avec le formatage FEC \"SIREN + FEC + YYYYMMDD\", veuillez renseigner vos numéros de SIREN et SIRET dans Mon Dossier. A défault, il sera remplacé par \"pasDeSiren\". ", -1)
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        (_ctx.noExportFecData)
                                          ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_col, null, {
                                                  default: _withCtx(() => _cache[85] || (_cache[85] = [
                                                    _createElementVNode("h3", { style: {"color":"red"} }, "Aucune donnée à exporter.", -1)
                                                  ])),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "d-flex py-2 align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "3" }, {
                                              default: _withCtx(() => [
                                                (_ctx.disabledPermanentFecBtn && _ctx.tooltipMessage)
                                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                      key: 0,
                                                      location: "top"
                                                    }, {
                                                      activator: _withCtx(({ props }) => [
                                                        _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                                          _createVNode(_component_v_checkbox, {
                                                            label: "Export normé définitif",
                                                            modelValue: _ctx.fecExportOptions.permanentFEC,
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fecExportOptions.permanentFEC) = $event)),
                                                            disabled: _ctx.disabledPermanentFecBtn,
                                                            color: "primary"
                                                          }, null, 8, ["modelValue", "disabled"])
                                                        ], 16)
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", null, _toDisplayString(_ctx.tooltipMessage), 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_v_checkbox, {
                                                      key: 1,
                                                      label: "Export normé définitif",
                                                      modelValue: _ctx.fecExportOptions.permanentFEC,
                                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fecExportOptions.permanentFEC) = $event)),
                                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onPermanentFecChange()))
                                                    }, null, 8, ["modelValue"]))
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "3" }, {
                                              default: _withCtx(() => [
                                                (!_ctx.unexportedAccountingItemCount)
                                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                      key: 0,
                                                      location: "top"
                                                    }, {
                                                      activator: _withCtx(({ props }) => [
                                                        _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                                          _createVNode(_component_v_checkbox, {
                                                            label: "Non exportés",
                                                            modelValue: 
                                                                _ctx.fecExportOptions.onlyNotExported
                                                            ,
                                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((
                                                                _ctx.fecExportOptions.onlyNotExported
                                                            ) = $event)),
                                                            disabled: "",
                                                            color: "primary"
                                                          }, null, 8, ["modelValue"])
                                                        ], 16)
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _cache[86] || (_cache[86] = _createElementVNode("span", null, "Aucune écriture non exportée", -1))
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : (_openBlock(), _createBlock(_component_v_checkbox, {
                                                      key: 1,
                                                      label: "Non exportés",
                                                      modelValue: _ctx.fecExportOptions.onlyNotExported,
                                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.fecExportOptions.onlyNotExported) = $event)),
                                                      onClick: _cache[12] || (_cache[12] = ($event: any) => {
                                                        _ctx.fecExportOptions.permanentFEC = false;
                                                        _ctx.fecDates();
                                                    })
                                                    }, null, 8, ["modelValue"]))
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "4",
                                              class: "px-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: _ctx.exportFileType,
                                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.exportFileType) = $event)),
                                                  items: _ctx.exportFileTypeList,
                                                  label: "Export de fichier",
                                                  "hide-details": "",
                                                  "item-title": "text"
                                                }, null, 8, ["modelValue", "items"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "px-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: _ctx.fecExportOptions.extentionFile,
                                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.fecExportOptions.extentionFile) = $event)),
                                                  items: _ctx.extentionFileList,
                                                  label: "Extension",
                                                  "hide-details": "",
                                                  "item-title": "text"
                                                }, null, 8, ["modelValue", "items"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "pr-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  modelValue: _ctx.fecExportOptions.startDate,
                                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fecExportOptions.startDate) = $event)),
                                                  label: "Date de début d'export",
                                                  mandatory: true,
                                                  textFieldReadOnly: false,
                                                  disabled: _ctx.disabledDatePicker,
                                                  minDate: 
                                                    _ctx.accountingPeriod && _ctx.accountingPeriod.start
                                                
                                                }, null, 8, ["modelValue", "disabled", "minDate"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "6" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  modelValue: _ctx.fecExportOptions.endDate,
                                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.fecExportOptions.endDate) = $event)),
                                                  label: "Date de fin d'export",
                                                  mandatory: true,
                                                  textFieldReadOnly: false,
                                                  disabled: _ctx.disabledDatePicker,
                                                  maxDate: _ctx.accountingPeriod && _ctx.accountingPeriod.end
                                                }, null, 8, ["modelValue", "disabled", "maxDate"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "py-2"
                                            }, {
                                              default: _withCtx(() => _cache[87] || (_cache[87] = [
                                                _createTextVNode(" Comptes auxiliaires ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "4" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field_filled, {
                                                  modelValue: _ctx.fecExportOptions.supplierPrefix,
                                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.fecExportOptions.supplierPrefix) = $event)),
                                                  label: "Prefixe fournisseurs",
                                                  outlined: "",
                                                  "hide-details": "",
                                                  density: "compact"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "4",
                                              class: "pl-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_text_field_filled, {
                                                  modelValue: _ctx.fecExportOptions.customerPrefix,
                                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.fecExportOptions.customerPrefix) = $event)),
                                                  label: "Préfixe clients",
                                                  outlined: "",
                                                  "hide-details": "",
                                                  density: "compact"
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "4",
                                              class: "pl-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  modelValue: _ctx.fecExportOptions.auxiliaryCharacterCount,
                                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.fecExportOptions.auxiliaryCharacterCount) = $event)),
                                                  label: "Nombre de caractères",
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "py-2"
                                            }, {
                                              default: _withCtx(() => _cache[88] || (_cache[88] = [
                                                _createTextVNode(" Comptes avec utilisateur ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_radio_group, {
                                                  modelValue: 
                                                    _ctx.fecExportOptions.accountableAccountWithUserAsSubAccount
                                                ,
                                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((
                                                    _ctx.fecExportOptions.accountableAccountWithUserAsSubAccount
                                                ) = $event)),
                                                  inline: "",
                                                  color: "primary"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_radio, {
                                                      label: "Avec un compte auxiliaire",
                                                      value: false
                                                    }),
                                                    _createVNode(_component_v_radio, {
                                                      label: "Avec un sous compte",
                                                      "data-cy": "ExportAccounting-compte",
                                                      value: true
                                                    })
                                                  ]),
                                                  _: 1
                                                }, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            (
                                                !_ctx.fecExportOptions.accountableAccountWithUserAsSubAccount
                                            )
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 0,
                                                  cols: "3"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field_filled, {
                                                      modelValue: _ctx.fecExportOptions.aa421Suffix,
                                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.fecExportOptions.aa421Suffix) = $event)),
                                                      label: "Prefixe salaire",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      density: "compact"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (
                                                !_ctx.fecExportOptions.accountableAccountWithUserAsSubAccount
                                            )
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 1,
                                                  cols: "3",
                                                  class: "pl-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field_filled, {
                                                      modelValue: _ctx.fecExportOptions.aa425Suffix,
                                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.fecExportOptions.aa425Suffix) = $event)),
                                                      label: "Préfixe note de frais",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      density: "compact"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (
                                                !_ctx.fecExportOptions.accountableAccountWithUserAsSubAccount
                                            )
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 2,
                                                  cols: "3",
                                                  class: "pl-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field_filled, {
                                                      modelValue: _ctx.fecExportOptions.aa455Suffix,
                                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.fecExportOptions.aa455Suffix) = $event)),
                                                      label: "Prefixe compte courant",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      density: "compact"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (
                                                !_ctx.fecExportOptions.accountableAccountWithUserAsSubAccount
                                            )
                                              ? (_openBlock(), _createBlock(_component_v_col, {
                                                  key: 3,
                                                  cols: "3",
                                                  class: "pl-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field_filled, {
                                                      modelValue: _ctx.fecExportOptions.aa467Suffix,
                                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.fecExportOptions.aa467Suffix) = $event)),
                                                      label: "Préfixe débiteur/créditeur",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      density: "compact"
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "py-2"
                                            }, {
                                              default: _withCtx(() => _cache[89] || (_cache[89] = [
                                                _createTextVNode(" Ecritures journaux de banques ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: _ctx.fecExportOptions.bankPieceRef,
                                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.fecExportOptions.bankPieceRef) = $event)),
                                                  items: _ctx.bankPieceRefs,
                                                  label: "Référence",
                                                  class: "pr-1",
                                                  "item-title": "text"
                                                }, null, 8, ["modelValue", "items"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              class: "pt-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_divider)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "pr-4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => _cache[90] || (_cache[90] = [
                                                        _createTextVNode("Comptes comptable")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "pt-1"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_select_filled, {
                                                          modelValue: 
                                                            _ctx.fecExportOptions.accountableAccountCharacterCount
                                                        ,
                                                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((
                                                            _ctx.fecExportOptions.accountableAccountCharacterCount
                                                        ) = $event)),
                                                          items: _ctx.accountableAccountCharacterCounts,
                                                          label: "Nombre de caractères",
                                                          "hide-details": "",
                                                          "item-title": "text"
                                                        }, null, 8, ["modelValue", "items"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "pr-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_row, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                      default: _withCtx(() => _cache[91] || (_cache[91] = [
                                                        _createTextVNode("Export")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "pt-1"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "12" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_select_filled, {
                                                          modelValue: _ctx.fecExportOptions.softwareExport,
                                                          "onUpdate:modelValue": [
                                                            _cache[27] || (_cache[27] = ($event: any) => ((_ctx.fecExportOptions.softwareExport) = $event)),
                                                            _cache[28] || (_cache[28] = ($event: any) => (_ctx.setFormatLimits()))
                                                          ],
                                                          items: _ctx.softwareExportTypeList,
                                                          "item-value": "value",
                                                          label: "Logiciel",
                                                          "hide-details": "",
                                                          density: "compact",
                                                          "item-title": (item) => item.text
                                                        }, null, 8, ["modelValue", "items", "item-title"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "export_fec_accountableAccounts" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "py-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "pl-3"
                                        }, {
                                          default: _withCtx(() => _cache[92] || (_cache[92] = [
                                            _createElementVNode("h4", null, "Correspondance de Comptes", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_switch, {
                                              modelValue: _ctx.displayUnmappedAccountableAccounts,
                                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.displayUnmappedAccountableAccounts) = $event)),
                                              label: "Afficher les éléments non mappés",
                                              "hide-details": "",
                                              class: "mt-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_form, {
                                      ref: "aaForm",
                                      modelValue: _ctx.isValidAccountableAccounts,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.isValidAccountableAccounts) = $event)),
                                      "lazy-validation": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_data_table, {
                                          dense: true,
                                          headers: _ctx.accAccHeaders,
                                          items: _ctx.filteredAccountableAccountItems,
                                          "items-per-page": -1,
                                          "fixed-header": "",
                                          "fixed-footer": true,
                                          "virtual-scroll": true,
                                          "table-hover": true,
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", {
                                              style: _normalizeStyle(
                                                    'background-color:' +
                                                    (props.item.description ? '' : '#F9B12A')
                                                )
                                            }, [
                                              _createElementVNode("td", _hoisted_1, _toDisplayString(props.item.name), 1),
                                              (props.item.missingDescription)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
                                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          class: "d-flex justify-center align-center"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_text_field_filled, {
                                                              modelValue: props.item.description,
                                                              "onUpdate:modelValue": ($event: any) => ((props.item.description) = $event),
                                                              class: "py-1",
                                                              outlined: "",
                                                              "hide-details": "",
                                                              rules: [
                                                                    (v) =>
                                                                        !!v ||
                                                                        _ctx.$t('settings.itemRequired'),
                                                                ],
                                                              density: "compact"
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(props.item.description), 1)),
                                              _createElementVNode("td", _hoisted_4, [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "12",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_text_field_filled, {
                                                          modelValue: props.item.export,
                                                          "onUpdate:modelValue": ($event: any) => ((props.item.export) = $event),
                                                          class: "py-1",
                                                          outlined: "",
                                                          "hide-details": "auto",
                                                          rules: [
                                                                    (v) =>
                                                                        !!v ||
                                                                        _ctx.$t('settings.itemRequired'),
                                                                    (v) =>
                                                                        v.length <=
                                                                            _ctx.fecExportOptions.accountableAccountCharacterCount ||
                                                                        _ctx.$t('settings.tooLong'),
                                                                ],
                                                          density: "compact"
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ], 4)
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "export_fec_bankAccounts" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "py-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "pl-3"
                                        }, {
                                          default: _withCtx(() => _cache[93] || (_cache[93] = [
                                            _createElementVNode("h4", null, "Correspondance de Banques", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_switch, {
                                              modelValue: _ctx.displayUnmappedBankAccounts,
                                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.displayUnmappedBankAccounts) = $event)),
                                              label: "Afficher les éléments non mappés",
                                              "hide-details": "",
                                              class: "mt-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_form, {
                                      ref: "baForm",
                                      modelValue: _ctx.isValidBankAccounts,
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.isValidBankAccounts) = $event)),
                                      "lazy-validation": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_data_table, {
                                          dense: "",
                                          headers: _ctx.bankAccountHeaders,
                                          items: _ctx.filteredBankAccountItems,
                                          "items-per-page": -1,
                                          "fixed-header": "",
                                          "fixed-footer": true,
                                          "virtual-scroll": true,
                                          "table-hover": true,
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_5, _toDisplayString(props.item.name), 1),
                                              _createElementVNode("td", _hoisted_6, [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "12",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_text_field_filled, {
                                                          modelValue: props.item.export,
                                                          "onUpdate:modelValue": ($event: any) => ((props.item.export) = $event),
                                                          outlined: "",
                                                          "hide-details": "auto",
                                                          color: "orange",
                                                          messages: 
                                                                    _ctx.getBankAccountTruncatedColor(
                                                                        props.item.export,
                                                                    )
                                                                ,
                                                          rules: [
                                                                    (v) =>
                                                                        !!v ||
                                                                        _ctx.$t('settings.itemRequired'),
                                                                ],
                                                          density: "compact"
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "messages", "rules"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "export_fec_users" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "py-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "pl-3"
                                        }, {
                                          default: _withCtx(() => _cache[94] || (_cache[94] = [
                                            _createElementVNode("h4", null, "Correspondance de Utilisateurs", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_switch, {
                                              modelValue: _ctx.displayUnmappedUsers,
                                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.displayUnmappedUsers) = $event)),
                                              label: "Afficher les éléments non mappés",
                                              "hide-details": "",
                                              class: "mt-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_form, {
                                      ref: "usersForm",
                                      modelValue: _ctx.isValidAccountableAccounts,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.isValidAccountableAccounts) = $event)),
                                      "lazy-validation": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_data_table, {
                                          dense: "",
                                          headers: _ctx.userHeaders,
                                          items: _ctx.filteredUserItems,
                                          "items-per-page": -1,
                                          "fixed-header": "",
                                          "fixed-footer": true,
                                          "virtual-scroll": true,
                                          "table-hover": true,
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_7, _toDisplayString(props.item.firstname), 1),
                                              _createElementVNode("td", _hoisted_8, _toDisplayString(props.item.lastname), 1),
                                              _createElementVNode("td", _hoisted_9, [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "12",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_text_field_filled, {
                                                          modelValue: props.item.export,
                                                          "onUpdate:modelValue": ($event: any) => ((props.item.export) = $event),
                                                          outlined: "",
                                                          "hide-details": "auto",
                                                          rules: 
                                                                    _ctx.getFecExportTableRules(
                                                                        props.item.name,
                                                                    )
                                                                ,
                                                          density: "compact"
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "export_fec_auxiliaires" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "py-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "pl-3"
                                        }, {
                                          default: _withCtx(() => _cache[95] || (_cache[95] = [
                                            _createElementVNode("h4", null, "Correspondance de Fournisseurs/Clients", -1)
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_switch, {
                                              modelValue: _ctx.displayUnmappedAuxiliaries,
                                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.displayUnmappedAuxiliaries) = $event)),
                                              label: "Afficher les éléments non mappés",
                                              "hide-details": "",
                                              class: "mt-0"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_form, {
                                      ref: "auxForm",
                                      modelValue: _ctx.isValidAccountableAccounts,
                                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.isValidAccountableAccounts) = $event)),
                                      "lazy-validation": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_data_table, {
                                          dense: "",
                                          headers: _ctx.auxiliaryHeaders,
                                          items: _ctx.filteredAuxiliaryItems,
                                          "items-per-page": -1,
                                          "fixed-header": "",
                                          "fixed-footer": true,
                                          "virtual-scroll": true,
                                          "table-hover": true,
                                          style: {"border":"1px #ededed solid"}
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_10, _toDisplayString(props.item.thirdPartyCompany), 1),
                                              _createElementVNode("td", _hoisted_11, _toDisplayString(props.item.type), 1),
                                              _createElementVNode("td", _hoisted_12, [
                                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                      cols: "12",
                                                      class: "d-flex justify-center align-center"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_text_field_filled, {
                                                          modelValue: props.item.export,
                                                          "onUpdate:modelValue": ($event: any) => ((props.item.export) = $event),
                                                          outlined: "",
                                                          "hide-details": "auto",
                                                          rules: 
                                                                    _ctx.getFecExportTableRules(
                                                                        props.item.name,
                                                                    )
                                                                ,
                                                          density: "compact"
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["headers", "items"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "export_log" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_form, {
                                      modelValue: _ctx.isExportLogValid,
                                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.isExportLogValid) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "mt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "pr-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  modelValue: _ctx.selectedLogs.startDate,
                                                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.selectedLogs.startDate) = $event)),
                                                  label: "Date de début d'export",
                                                  mandatory: true,
                                                  textFieldReadOnly: false,
                                                  disabled: _ctx.disabledDatePicker,
                                                  minDate: 
                                                    _ctx.accountingPeriod && _ctx.accountingPeriod.start
                                                ,
                                                  prefixDataCy: "ExportAccounting-beginDate"
                                                }, null, 8, ["modelValue", "disabled", "minDate"])
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, { cols: "6" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  modelValue: _ctx.selectedLogs.endDate,
                                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.selectedLogs.endDate) = $event)),
                                                  label: "Date de fin d'export",
                                                  mandatory: true,
                                                  textFieldReadOnly: false,
                                                  disabled: _ctx.disabledDatePicker,
                                                  maxDate: _ctx.accountingPeriod && _ctx.accountingPeriod.end,
                                                  prefixDataCy: "ExportAccounting-endDate"
                                                }, null, 8, ["modelValue", "disabled", "maxDate"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "export_log_1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "d-flex justify-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            (_ctx.logList.global && !_ctx.logList.global.length)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Aucune donnée sur la periode " + _toDisplayString(_ctx.formatDate(_ctx.selectedLogs.startDate)) + " - " + _toDisplayString(_ctx.formatDate(_ctx.selectedLogs.endDate)), 1))
                                              : (_openBlock(), _createBlock(_component_v_row, {
                                                  key: 1,
                                                  "no-gutters": ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "12" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item, {
                                                          link: "",
                                                          class: _normalizeClass(
                                                        !_ctx.$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    )
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_checkbox, {
                                                              "input-value": _ctx.allSelected,
                                                              ripple: false,
                                                              indeterminate: _ctx.allSelectedIndeterminate,
                                                              onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.selectAll(_ctx.allSelected))),
                                                              "data-cy": "ExportAccounting-allSelected",
                                                              value: _ctx.allSelected
                                                            }, null, 8, ["input-value", "indeterminate", "value"]),
                                                            _createVNode(_component_v_list_item_title, null, {
                                                              default: _withCtx(() => _cache[96] || (_cache[96] = [
                                                                _createTextVNode(" Tout sélectionner ")
                                                              ])),
                                                              _: 1
                                                            })
                                                          ]),
                                                          _: 1
                                                        }, 8, ["class"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })),
                                            (
                                                _ctx.logList && _ctx.logList.global && _ctx.logList.global.length
                                            )
                                              ? (_openBlock(), _createBlock(_component_v_list, {
                                                  key: 2,
                                                  subheader: ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logList.global, (item, index) => {
                                                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                        (item.type === 'PURCHASE_INVOICE')
                                                          ? (_openBlock(), _createBlock(_component_v_list_group, {
                                                              key: 0,
                                                              class: _normalizeClass(
                                                        !_ctx.$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    ),
                                                              "model-value": false
                                                            }, {
                                                              activator: _withCtx(() => [
                                                                _createVNode(_component_v_checkbox, {
                                                                  modelValue: _ctx.selectedLogs.global,
                                                                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.selectedLogs.global) = $event)),
                                                                  ripple: false,
                                                                  indeterminate: _ctx.purchasesIndeterminate,
                                                                  onClick: _withModifiers(($event: any) => (
                                                                _ctx.selectLogListGlobal(item.type)
                                                            ), ["stop"]),
                                                                  value: item.type
                                                                }, null, 8, ["modelValue", "indeterminate", "onClick", "value"]),
                                                                _createVNode(_component_v_list_item_title, null, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("b", null, _toDisplayString(_ctx.$t(
                                                                        "accountingItem.type." +
                                                                            item.type,
                                                                    )), 1),
                                                                    _createTextVNode(" (" + _toDisplayString(item.count) + ") ", 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              default: _withCtx(() => [
                                                                (
                                                            _ctx.logList &&
                                                            _ctx.logList.purchases &&
                                                            _ctx.logList.purchases.length
                                                        )
                                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.logList.purchases, (purch, i) => {
                                                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                        key: i,
                                                                        link: "",
                                                                        class: _normalizeClass(
                                                                !_ctx.$vuetify.display.mobile
                                                                    ? 'mb-2 mx-2 oss-list-item'
                                                                    : 'mb-2 mx-2 px-2 oss-list-item'
                                                            )
                                                                      }, {
                                                                        prepend: _withCtx(() => [
                                                                          _createVNode(_component_v_checkbox, {
                                                                            modelValue: 
                                                                        _ctx.selectedLogs.purchaseThirdParty
                                                                    ,
                                                                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((
                                                                        _ctx.selectedLogs.purchaseThirdParty
                                                                    ) = $event)),
                                                                            ripple: false,
                                                                            onClick: _withModifiers(($event: any) => (
                                                                        _ctx.selectLogSubList(item.type)
                                                                    ), ["stop"]),
                                                                            value: purch.id
                                                                          }, null, 8, ["modelValue", "onClick", "value"])
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                          _createVNode(_component_v_list_item_title, null, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode(_toDisplayString(purch.thirdParty) + " (" + _toDisplayString(purch.count) + ") ", 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1024)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["class"]))
                                                                    }), 128))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["class"]))
                                                          : (item.type === 'SALES_INVOICE')
                                                            ? (_openBlock(), _createBlock(_component_v_list_group, {
                                                                key: 1,
                                                                class: _normalizeClass(
                                                        !_ctx.$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    ),
                                                                "model-value": false
                                                              }, {
                                                                activator: _withCtx(() => [
                                                                  _createVNode(_component_v_checkbox, {
                                                                    modelValue: _ctx.selectedLogs.global,
                                                                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.selectedLogs.global) = $event)),
                                                                    ripple: false,
                                                                    indeterminate: _ctx.salesIndeterminate,
                                                                    onClick: _withModifiers(($event: any) => (
                                                                _ctx.selectLogListGlobal(item.type)
                                                            ), ["stop"]),
                                                                    value: item.type
                                                                  }, null, 8, ["modelValue", "indeterminate", "onClick", "value"]),
                                                                  _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => [
                                                                      _createElementVNode("b", null, _toDisplayString(_ctx.$t(
                                                                        "accountingItem.type." +
                                                                            item.type,
                                                                    )), 1),
                                                                      _createTextVNode(" (" + _toDisplayString(item.count) + ") ", 1)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                  (
                                                            _ctx.logList &&
                                                            _ctx.logList.sales &&
                                                            _ctx.logList.sales.length
                                                        )
                                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.logList.sales, (sale, i) => {
                                                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                          key: i,
                                                                          link: "",
                                                                          class: _normalizeClass(
                                                                !_ctx.$vuetify.display.mobile
                                                                    ? 'mb-2 mx-2 oss-list-item'
                                                                    : 'mb-2 mx-2 px-2 oss-list-item'
                                                            )
                                                                        }, {
                                                                          prepend: _withCtx(() => [
                                                                            _createVNode(_component_v_checkbox, {
                                                                              modelValue: 
                                                                        _ctx.selectedLogs.salesThirdParty
                                                                    ,
                                                                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((
                                                                        _ctx.selectedLogs.salesThirdParty
                                                                    ) = $event)),
                                                                              ripple: false,
                                                                              onClick: _withModifiers(($event: any) => (
                                                                        _ctx.selectLogSubList(item.type)
                                                                    ), ["stop"]),
                                                                              value: sale.id
                                                                            }, null, 8, ["modelValue", "onClick", "value"])
                                                                          ]),
                                                                          default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, null, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(sale.thirdParty) + " (" + _toDisplayString(sale.count) + ") ", 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ]),
                                                                          _: 2
                                                                        }, 1032, ["class"]))
                                                                      }), 128))
                                                                    : _createCommentVNode("", true)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["class"]))
                                                            : (item.type === 'BANK')
                                                              ? (_openBlock(), _createBlock(_component_v_list_group, {
                                                                  key: 2,
                                                                  class: _normalizeClass(
                                                        !_ctx.$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    ),
                                                                  "model-value": false
                                                                }, {
                                                                  prepend: _withCtx(() => [
                                                                    _createVNode(_component_v_checkbox, {
                                                                      modelValue: _ctx.selectedLogs.global,
                                                                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.selectedLogs.global) = $event)),
                                                                      ripple: false,
                                                                      indeterminate: _ctx.banksIndeterminate,
                                                                      onClick: _withModifiers(($event: any) => (
                                                                _ctx.selectLogListGlobal(item.type)
                                                            ), ["stop"]),
                                                                      value: item.type
                                                                    }, null, 8, ["modelValue", "indeterminate", "onClick", "value"])
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => [
                                                                        _createElementVNode("b", null, _toDisplayString(_ctx.$t(
                                                                    "accountingItem.type." +
                                                                        item.type,
                                                                )), 1),
                                                                        _createTextVNode(" (" + _toDisplayString(item.count) + ") ", 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024),
                                                                    (
                                                            _ctx.logList &&
                                                            _ctx.logList.banks &&
                                                            _ctx.logList.banks.length
                                                        )
                                                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.logList.banks, (b, i) => {
                                                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                            key: i,
                                                                            link: "",
                                                                            class: _normalizeClass(
                                                                !_ctx.$vuetify.display.mobile
                                                                    ? 'mb-2 mx-2 oss-list-item'
                                                                    : 'mb-2 mx-2 px-2 oss-list-item'
                                                            )
                                                                          }, {
                                                                            prepend: _withCtx(() => [
                                                                              _createVNode(_component_v_checkbox, {
                                                                                modelValue: _ctx.selectedLogs.banks,
                                                                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.selectedLogs.banks) = $event)),
                                                                                ripple: false,
                                                                                onClick: _withModifiers(($event: any) => (
                                                                        _ctx.selectLogSubList(item.type)
                                                                    ), ["stop"]),
                                                                                value: b.id
                                                                              }, null, 8, ["modelValue", "onClick", "value"])
                                                                            ]),
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_v_list_item_title, null, {
                                                                                default: _withCtx(() => [
                                                                                  _createTextVNode(_toDisplayString(b.name) + " (" + _toDisplayString(b.count) + ") ", 1)
                                                                                ]),
                                                                                _: 2
                                                                              }, 1024)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["class"]))
                                                                        }), 128))
                                                                      : _createCommentVNode("", true)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["class"]))
                                                              : (_openBlock(), _createBlock(_component_v_list_item, {
                                                                  key: 3,
                                                                  class: _normalizeClass(
                                                        !_ctx.$vuetify.display.mobile
                                                            ? 'mb-2 oss-list-item'
                                                            : 'mb-2 px-2 oss-list-item'
                                                    )
                                                                }, {
                                                                  prepend: _withCtx(() => [
                                                                    _createVNode(_component_v_checkbox, {
                                                                      modelValue: _ctx.selectedLogs.global,
                                                                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.selectedLogs.global) = $event)),
                                                                      ripple: false,
                                                                      value: item.type
                                                                    }, null, 8, ["modelValue", "value"])
                                                                  ]),
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, null, {
                                                                      default: _withCtx(() => [
                                                                        _createElementVNode("b", null, _toDisplayString(_ctx.$t(
                                                                    "accountingItem.type." +
                                                                        item.type,
                                                                )), 1),
                                                                        _createTextVNode(" (" + _toDisplayString(item.count) + ") ", 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["class"]))
                                                      ]))
                                                    }), 128))
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "" }),
                                _createVNode(_component_v_window_item, { value: "export_log_2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list, {
                                      subheader: "",
                                      lines: "two"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: _ctx.exportWithProjectWatermark,
                                              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.exportWithProjectWatermark) = $event)),
                                              ripple: false,
                                              class: "ml-1 mb-4",
                                              title: _ctx.$t('shared.exportWithProjectWatermark'),
                                              label: _ctx.$t('shared.exportWithProjectWatermark')
                                            }, null, 8, ["modelValue", "title", "label"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_list_item, {
                                          class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        ),
                                          disabled: _ctx.exportWithProjectWatermark,
                                          onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.exportFile('XLSX'))),
                                          "data-cy": "ExportAccounting-excel"
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_icon, { color: "secondary" }, {
                                              default: _withCtx(() => _cache[97] || (_cache[97] = [
                                                _createTextVNode(" $fa-file-excel ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_btn_next)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => _cache[98] || (_cache[98] = [
                                                _createTextVNode("Excel")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_list_item_subtitle, null, {
                                              default: _withCtx(() => _cache[99] || (_cache[99] = [
                                                _createTextVNode("Exporter au format .xlsx")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["class", "disabled"]),
                                        _createVNode(_component_v_list_item, {
                                          class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item rounded-lg'
                                                : 'mb-2 px-2 oss-list-item rounded-lg'
                                        ),
                                          onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.exportFile('DOCX'))),
                                          "data-cy": "ExportAccounting-docx"
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_icon, { color: "secondary" }, {
                                              default: _withCtx(() => _cache[100] || (_cache[100] = [
                                                _createTextVNode(" $fa-file-word ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_btn_next)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => _cache[101] || (_cache[101] = [
                                                _createTextVNode("Docx")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_list_item_subtitle, null, {
                                              default: _withCtx(() => _cache[102] || (_cache[102] = [
                                                _createTextVNode("Exporter au format .docx")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["class"]),
                                        _createVNode(_component_v_list_item, {
                                          class: _normalizeClass(
                                            !_ctx.$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item rounded-lg'
                                                : 'mb-2 px-2 oss-list-item rounded-lg'
                                        ),
                                          onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.exportFile('PDF'))),
                                          "data-cy": "ExportAccounting-PDF"
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_icon, { color: "secondary" }, {
                                              default: _withCtx(() => _cache[103] || (_cache[103] = [
                                                _createTextVNode(" $fa-file-pdf ")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_btn_next)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, null, {
                                              default: _withCtx(() => _cache[104] || (_cache[104] = [
                                                _createTextVNode("PDF")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_list_item_subtitle, null, {
                                              default: _withCtx(() => _cache[105] || (_cache[105] = [
                                                _createTextVNode("Exporter au format .pdf")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["class"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "date-picker" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "d-flex justify-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "4",
                                          class: "pt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_date_picker_wrapper, {
                                              modelValue: _ctx.dateSelected,
                                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.dateSelected) = $event)),
                                              color: "secondary",
                                              "first-day-of-week": "1",
                                              scrollable: "",
                                              "full-width": "",
                                              "hide-header": "",
                                              landscape: !_ctx.$vuetify.display.mobile
                                            }, null, 8, ["modelValue", "landscape"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "export_extensions" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extensions, (ext) => {
                                      return (_openBlock(), _createBlock(_component_v_list_item, {
                                        class: _normalizeClass(
                                        !_ctx.$vuetify.display.mobile
                                            ? 'mb-2 oss-list-item'
                                            : 'mb-2 px-2 oss-list-item'
                                    ),
                                        key: ext.id,
                                        onClick: ($event: any) => {
                                        _ctx.step = 'display_extension';
                                        _ctx.selectedExtension = ext;
                                    }
                                      }, {
                                        append: _withCtx(() => [
                                          _createVNode(_component_v_btn_next)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(ext.name), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "onClick"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "display_extension" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_14, [
                                      (_ctx.selectedExtension)
                                        ? (_openBlock(), _createBlock(_component_oss_widget_embedder, _mergeProps({ key: 0 }, _ctx.selectedExtension, {
                                            onClose: _cache[54] || (_cache[54] = ($event: any) => (_ctx.step = 'export_extensions'))
                                          }), null, 16))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_window_item, { value: "export_office_1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "d-flex justify-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "10",
                                          class: "py-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list, { style: {"background":"transparent"} }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exportOfficeList, (item, index) => {
                                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                                    key: index,
                                                    ripple: "",
                                                    class: "ma-1 oss-list-item",
                                                    onClick: ($event: any) => (_ctx.exportOfficeFile(item))
                                                  }, {
                                                    prepend: _withCtx(() => [
                                                      _createVNode(_component_v_icon, { color: "secondary" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(["xlsx", "xls", "xlsm"].includes(
                                                                item.filename.split(".").pop(),
                                                            )
                                                                ? "$fa-file-excel"
                                                                : "$fa-file-word"), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    append: _withCtx(() => [
                                                      _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => _cache[106] || (_cache[106] = [
                                                          _createTextVNode("$chevron_right")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_v_list_item_subtitle, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString("Fichier associé : " + item.filename), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "previous-display", "previous-disabled", "onClose"]),
                        (_ctx.accountingBookletDialog)
                          ? (_openBlock(), _createBlock(_component_AccountingBooklet, {
                              key: 1,
                              modelValue: _ctx.accountingBookletDialog,
                              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.accountingBookletDialog) = $event)),
                              onBack: _cache[60] || (_cache[60] = ($event: any) => {
                            _ctx.accountingBookletDialog = false;
                            _ctx.exportDialog = true;
                        }),
                              onExportStarted: _cache[61] || (_cache[61] = ($event: any) => (_ctx.refresh()))
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_data_table_server, {
              headers: _ctx.exportHeaders,
              items: _ctx.accountingItemExports,
              page: _ctx.paginationExport.page,
              "onUpdate:page": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.paginationExport.page) = $event)),
              "sort-by": _ctx.paginationExport.sortBy,
              "onUpdate:sortBy": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.paginationExport.sortBy) = $event)),
              "items-per-page": _ctx.paginationExport.rowsPerPage,
              "onUpdate:itemsPerPage": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.paginationExport.rowsPerPage) = $event)),
              "items-per-page-options": [5, 10, 25],
              "items-length": _ctx.paginationExport.totalItems,
              class: "table",
              "fixed-header": "",
              "max-height": "60vh"
            }, {
              item: _withCtx(({ item }) => [
                _createElementVNode("tr", _hoisted_15, [
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, [
                    (item.status === 'EXPORTED_WITH_ERRORS')
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          color: "error",
                          size: "small",
                          location: "start"
                        }, {
                          default: _withCtx(() => _cache[107] || (_cache[107] = [
                            _createTextVNode("$fa-times")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`accountingItemExport.status.${item.status}`)) + " ", 1),
                    (item.status.startsWith('RUNNING') && item.stepCount)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 1,
                          height: "10",
                          "buffer-value": "0",
                          stream: "",
                          "model-value": (100 * item.step) / item.stepCount
                        }, null, 8, ["model-value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.getAccountingPeriodTitle(item)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDateAndTime(item.updatedAt || item.createdAt)), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createVNode(_component_v_btn_trash, {
                      onClick: _withModifiers(($event: any) => (_ctx.openDeleteDialog(item.id)), ["stop"]),
                      disabled: _ctx.deleteDisabled(item),
                      "data-cy": 'ExportAccounting-delete-' + item.id,
                      size: "small"
                    }, null, 8, ["onClick", "disabled", "data-cy"])
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _createVNode(_component_v_btn_icon, {
                      icon: "$fa-cloud-download-alt",
                      color: "secondary",
                      disabled: !item.file,
                      onClick: _withModifiers(($event: any) => (_ctx.directDownload(item)), ["stop"]),
                      "data-cy": 'ExportAccounting-download-' + item.id
                    }, null, 8, ["disabled", "onClick", "data-cy"]),
                    _createVNode(_component_v_tooltip, { location: "top" }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$fa-share" }, props, {
                          color: "secondary",
                          disabled: 
                                            !item.file ||
                                            !!(
                                                item.file.originalDocuments &&
                                                item.file.originalDocuments.length
                                            )
                                        ,
                          "data-cy": 'ExportAccounting-publier-' + item.id,
                          onClick: _withModifiers(($event: any) => (_ctx.publish(item)), ["stop"])
                        }), null, 16, ["disabled", "data-cy", "onClick"])
                      ]),
                      default: _withCtx(() => [
                        _cache[108] || (_cache[108] = _createElementVNode("span", null, " Partager au client ", -1))
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["headers", "items", "page", "sort-by", "items-per-page", "items-length"]),
            _createVNode(_component_oss_dialog, {
              modelValue: _ctx.deleteAccountingItemExportDialog,
              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.deleteAccountingItemExportDialog) = $event)),
              title: "Supprimer",
              error: true,
              onValid: _ctx.deleteEditAccountingItemExport,
              validLoading: _ctx.deleteAccountingItemExportLoading,
              prefixDataCy: "ExportAccounting-validDelete",
              width: "800px"
            }, {
              default: _withCtx(() => _cache[109] || (_cache[109] = [
                _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer l'export ?", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "onValid", "validLoading"]),
            (_ctx.exportGeneralLedgerDialog)
              ? (_openBlock(), _createBlock(_component_GeneralLedgerExportDialog, {
                  key: 1,
                  exportGeneralLedgerDialog: _ctx.exportGeneralLedgerDialog,
                  "onUpdate:exportGeneralLedgerDialog": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.exportGeneralLedgerDialog) = $event)),
                  companyId: _ctx.companyId,
                  accountingPeriodId: _ctx.accountingPeriod.id,
                  fromExportAccounting: true,
                  accountableAccountsSelected: undefined,
                  onExportFileFinished: _ctx.onExportFileFinished,
                  "data-cy": "ExportAccounting-telechargement"
                }, null, 8, ["exportGeneralLedgerDialog", "companyId", "accountingPeriodId", "onExportFileFinished"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}